import React from "react";
// import './PagingSelect.css'
import { v4 } from 'uuid'

interface ItemModel {
    label: string
    value: string
}

interface Props {
    items: ItemModel[]
    value: string
    changeTake: (_take: number) => void
}

const PagingSelect = ({ items, value, changeTake }: Props) => {
    return (
        <select onChange={(e) => changeTake(parseInt(e.target.value))} value={value} className="form-select form-select-sm custom-PagingSelect">
            {
                items.map((item, index) =>
                    <option key={v4()} value={item.value}>{item.label}</option>
                )
            }
        </select>
    )
}

export default PagingSelect;